import Choices from 'choices.js'

export default class CategoryPageAnchor {

	constructor(naja) {
		naja.addEventListener('init', CategoryPageAnchor._init.bind(this));
		naja.snippetHandler.addEventListener('afterUpdate', CategoryPageAnchor._init.bind(this));
	}

	static _init() {
		let inputs = document.querySelectorAll('input.fn_watchdog_choices');
		if (inputs.length > 0) {
			new Choices('input.fn_watchdog_choices', {
				removeItemButton: true,
				resetScrollPosition: false,
				addItems: true,
				editItems: false,
				duplicateItemsAllowed: false,
			});
			inputs.forEach(function (el) {
				el.classList.remove('fn_watchdog_choices');
			});
		}
	}
}